import { on } from '@utils/events.js'
import { h } from '@utils/html.js'
import Form from '../../utils/Form.js'
import { translate } from '@modules/locale/locale.js'
import { popup } from '@modules/popup/popup.js'

on('submit', document, '.js-open-suggest-place-form-popup', (e) => {
    e.preventDefault()

    const articleId = e.target.querySelector('input[name="articleId"]').value
    const feedbackInput = e.target.querySelector('input[name="feedback"]')
    const feedback = feedbackInput ? feedbackInput.value : ''
    const email = e.target.querySelector('input[name="email"]')?.value || ''

    const suggestionTemplate = h(`
		<form class="pretty-form" action="/article/place-suggestion/${articleId}/">
			<div class="form-group hidden" aria-hidden="true">
				<input type="text" name="firstname" style="display: none;" tabindex="-1" autocomplete="off">
			</div>

			<h2 class="text-center text-2xl bold mb-4">${translate('article_suggestion_popup_title')}</h2>

			<div class="form-group">
				<input class="w-full" type="text" name="feedback" value="" placeholder="${translate(
                    'article_suggestion_popup_place_placeholder',
                )}" required />
			</div>

			<div class="form-group">
				<input class="w-full" type="email" name="userEmail" placeholder="${translate(
                    'common_email',
                )}" required />
			</div>

			<div class="form-group">
				<textarea class="w-full" name="other" placeholder="${translate(
                    'article_suggestion_popup_other_placeholder',
                )}"></textarea>
			</div>

			<p class="text-center">${translate('article_suggestion_popup_owner_note')}</p>

			<div class="form-group inline d-flex jc-center">
				<div class="radio mr-4">
					<input class="w-full" id="suggestion_owner_yes" name="suggestionOwner" type="radio" value="true">
					<label for="suggestion_owner_yes">${translate('common_yes')}</label>
				</div>

				<div class="radio">
					<input class="w-full" id="suggestion_owner_no" name="suggestionOwner" type="radio" value="false">
					<label for="suggestion_owner_no">${translate('common_no')}</label>
				</div>
			</div>

			<div class="form-group hidden js-suggestion-owner-fields">
				<div class="form-group">
					<input class="w-full" type="text" name="owner[name]" required disabled placeholder="${translate(
                        'common_name',
                    )}">
				</div>

				<div class="form-group">
					<input class="w-full" type="tel" name="owner[phoneNumber]" required disabled placeholder="${translate(
                        'common_phone',
                    )}">
				</div>

				<div class="form-group">
					<p class="gdpr text-xs text-center text-italic">
						${translate('article_suggestion_popup_privacy_notice')}
					</p>
				</div>
			</div>

			<p class="explanation error text-center"></p>

			<div class="form-group">
				<button class="flat-button flat-button--blue flat-button--full mt-4" type="submit">
					${translate('common_send')}
				</button>
			</div>
		</form>
	`)

    const templateFeedbackInput = suggestionTemplate.querySelector('input[name="feedback"]')
    templateFeedbackInput.value = feedback
    const templateEmailInput = suggestionTemplate.querySelector('input[name="userEmail"]')
    templateEmailInput.value = email

    // Toggle between owner
    on('change', suggestionTemplate, 'input[type="radio"]', (e) => {
        const isOwner = e.target.value === 'true'
        const suggestionOwnerFields = suggestionTemplate.querySelector(
            '.js-suggestion-owner-fields',
        )

        if (isOwner) {
            suggestionTemplate.querySelector('input[name="userEmail"]').required = true
            suggestionOwnerFields.classList.remove('hidden')
        } else {
            suggestionTemplate.querySelector('input[name="userEmail"]').required = false
            suggestionOwnerFields.classList.add('hidden')
        }

        suggestionOwnerFields.querySelectorAll('input').forEach((el) => {
            el.disabled = !isOwner
        })
    })

    Form.find(suggestionTemplate)
        .init()
        .then(() => {
            // Clear footer input value
            if (feedbackInput) {
                feedbackInput.value = ''
            }

            // Open thank you popup
            const popupInstance = popup({
                content: `
				<div class="text-center">
					<h2 class="text-2xl bold mb-2">${translate('article_suggestion_popup_thank_you_title')}</h2>
					<p>${translate('article_suggestion_popup_thank_you_description')}</p>

					<button class="flat-button flat-button--blue flat-button--full close-button mt-4">${translate(
                        'article_suggestion_popup_thank_you_welcome',
                    )}</button>
				</div>
			`,
                width: 400,
            })

            on('click', popupInstance.contentContainer, '.close-button', () => {
                popupInstance.close()
            })
        })
        .catch(() => {
            const errorElement = suggestionTemplate.querySelector('.error')

            errorElement.innerText =
                translate('something_went_wrong') + '. ' + translate('try_again') + '.'
        })

    popup({
        title: null,
        content: suggestionTemplate,
        width: 400,
        afterOpen() {
            // templateFeedbackInput.focus()
            // Buggy focus on mobile
        },
    })
})
